import cityLocationsMapStyles from './city-locations-map';
import { getPopupClass } from './popup.js';

const ICONS = {
  'active': {url: '/Assets/images/location-active.png', scaledSize: {width: 66, height: 35}},
  'inactive' : '/Assets/images/location-inactive.svg'
}

export default class CityLocationsMap{
  constructor(){
    if(window.franchiseMapContent){
      this.map = this.createMap();
      this.locations = window.franchiseMapContent.Warehouses;
      this.markers = this.setMarkers();
      this.activeLocation = 0;
      this.setActiveWarehouse(0);
      this.setMapBounds();
      this.addEventListeners();
    }
  }

  createMap(){
    return new google.maps.Map(document.getElementById('franchise-map'), {
      gestureHandling: 'greedy',
      fullscreenControl: false,
      mapTypeControl: false,
      styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#c9c9c9"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ]
    });
  }

  setMarkers(){
    var Popup = getPopupClass();
    return this.locations.map((location)=>{
      let marker = new google.maps.Marker({
        position: {lat: parseFloat(location.Latitude), lng: parseFloat(location.Longitude)},
        icon: ICONS['inactive'],
        map: this.map
      });
      let content = document.createElement('div');
      content.innerHTML = (
        `<div>
        <h5>${location.Name}</h5>
        <p>${location.AddressLine1}<br/>
        ${location.City}, ${location.StateProvince}, ${location.PostalCode}</p>
      </div>`
      )
      let popup = new Popup(marker.position, content);
      popup.setMap(this.map);
      popup.hide();
      marker.addListener('mouseover', ()=>{popup.show()});
      marker.addListener('mouseout', ()=>{popup.hide()});
      return marker;
    })
  }

  setActiveWarehouse(locationIndex){
    if(this.activeLocation > -1){
      document.getElementById('warehouse-list-item-'+this.activeLocation).classList.remove('active');
      this.markers[this.activeLocation].setIcon(ICONS['inactive']);
    }
    this.activeLocation = locationIndex;
    if(this.locations.length > 1){
      document.getElementById('warehouse-list-item-'+this.activeLocation).classList.add('active');
    }
    let selectedMarker = this.markers[this.activeLocation];
    selectedMarker.setIcon(ICONS['active']);
    this.map.panTo(selectedMarker.getPosition());
  }

  activateMarker(locationIndex){
    let selectedMarker = this.markers[locationIndex];
    selectedMarker.setIcon(ICONS['active']);
  }

  deactivateMarker(locationIndex){
    if(this.activeLocation != locationIndex){
      this.markers[locationIndex].setIcon(ICONS['inactive']);
    }
  }

  addEventListeners(){
    this.locations.forEach((location, locationIndex)=>{
      let warehouseItem = document.getElementById('warehouse-list-item-'+ locationIndex);
      let currMarker = this.markers[locationIndex];
      warehouseItem.addEventListener('click', this.setActiveWarehouse.bind(this, locationIndex));
      warehouseItem.addEventListener('mouseover', this.activateMarker.bind(this, locationIndex));
      warehouseItem.addEventListener('mouseout', this.deactivateMarker.bind(this, locationIndex));
      currMarker.addListener('click', this.setActiveWarehouse.bind(this, locationIndex));
    });
  }

  setMapBounds(){
    let bounds = new google.maps.LatLngBounds();
    this.markers.forEach(function(marker){
      bounds.extend(marker.getPosition());
    })
    if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
      var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
      var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
      bounds.extend(extendPoint1);
      bounds.extend(extendPoint2);
    }
    this.map.fitBounds(bounds);
  }
}
